<div class="container-fluid" style="background-color:#fff;">
  <div class="row">
    <div class="col-lg-4 mx-auto" style="margin-top:250px;">
      <mat-spinner [diameter]="50" class="mx-auto"></mat-spinner>
      <h3 class="text-center">Logging out...</h3>
    </div>
  </div>
</div>
